<script lang="ts">
    // Import Swiper Svelte components
    import { Swiper, SwiperSlide } from "swiper/svelte"
    import SwiperCore, { Navigation, Pagination, EffectFade, Autoplay } from "swiper"
    import { content, location } from "../../store"
    import { apiBaseURL } from "../../config"
    import HeroSlide from "./HeroSlide.svelte"

    SwiperCore.use([EffectFade, Navigation, Pagination, Autoplay])

    // swiper ts types for autoplay invalid, see swiper docs
    // @ts-ignore
    const autoplayOptions: boolean = {
        delay: 4000,
    }
</script>

{#if $content?.slider?.length}
    {#key $location.path}
        <section class="slider_holder hero_slider">
            {#if $content.slider.length == 1 || typeof window === "undefined"}
                <!-- swiper does not work with ssr -->
                <HeroSlide item="{$content.slider[0]}" baseURL="{apiBaseURL + 'content/' + $content.id + '/'}" />
            {:else}
                <Swiper effect="fade" navigation pagination="{{ clickable: true }}" autoplay="{autoplayOptions}">
                    {#each $content.slider as item}
                        <SwiperSlide>
                            <HeroSlide {item} baseURL="{apiBaseURL + 'content/' + $content.id + '/'}" />
                        </SwiperSlide>
                    {/each}
                </Swiper>
            {/if}
        </section>
    {/key}
{/if}

<style lang="less" global>
    @import "swiper/swiper.less";
    @import "swiper/modules/effect-fade/effect-fade.less";
    @import "swiper/modules/navigation/navigation.less";
    @import "swiper/modules/pagination/pagination.less";

    @import "../../css/variables.less";
    .hero_slider {
        .swiper {
            height: 100%;
        }
        .swiper-pagination-bullet {
            width: 12px;
            height: 12px;
            background: var(--surface);
            color: var(--on-surface);
        }
        .swiper-pagination-bullet-active {
            background: var(--primary);
            color: var(--on-primary);
        }
        .swiper-button-prev,
        .swiper-button-next {
            color: var(--surface);
            &:after {
                font-size: 25px;
                @media (min-width: 768px) {
                    font-size: 35px;
                }
            }
        }

        &.slider_holder {
            position: relative;
            overflow: hidden;
            width: 100%;
        }

        height: 30vw;
        @media (max-width: 768px) {
            height: 50vw;
        }
    }

    .slide {
        position: absolute;
        top: 0px;
        bottom: 0;
        width: 100%;
        .image {
            height: 100%;
            width: 100%;
            img,
            video,
            .video-js {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .text {
            position: absolute;
            top: 0px;
            left: 0px;
            right: 0px;
            bottom: 0px;
            font-size: 2em;
            color: white;
            font-weight: bold;
            width: 100%;
            text-align: center;
            background: rgba(0, 0, 0, 0.4);
            .flex();
            align-items: center;
            justify-content: flex-end;
            flex-direction: column;
            @media (max-width: 768px) {
                padding: 0px 40px;
            }
            .btn {
                padding: 12px 30px;
            }
            .text_inner {
                .flex();
                justify-content: flex-end;
                flex-direction: column;
                align-items: center;
                margin-bottom: 50px;
                @media (max-width: 500px) {
                    margin-bottom: 40px;
                }
                line-height: 1;
                .headline {
                    font-size: 3.5vw;
                    margin-bottom: 20px;
                    @media (max-width: 768px) {
                        font-size: 6vw;
                        margin-bottom: 10px;
                    }
                    @media (max-width: 500px) {
                        font-size: 2rem;
                    }
                }
            }
        }
    }
</style>
